// Maps an author_name string to a public photo path.
// Files in /public are served at the root in production.
// Matching is by first name (case-insensitive). Falls back to initials avatar.

const NAME_TO_PHOTO = {
  development: '/hl logo.png',
  haringey:    '/hl logo.png',
  giuseppe:    '/giuseppe.jpg',
  roushanara:  '/roushanara.jpeg',
  andrew:      '/andrew.jpeg',
};

export const getAuthorPhoto = (authorName) => {
  if (!authorName) return null;
  const firstName = authorName.trim().split(/\s+/)[0].toLowerCase();
  return NAME_TO_PHOTO[firstName] || null;
};

export const getAuthorInitials = (authorName) => {
  if (!authorName) return '?';
  const parts = authorName.trim().split(/\s+/);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return parts[0][0].toUpperCase();
};
